import React, { useContext, useState } from 'react';
import Moment from 'react-moment';
import { Row, Col, Form, Input, Button, Select, Modal, DatePicker, message, Spin } from 'antd';
import { Context } from '../../../context/AuthContext';
import MonetaryConverter from '../../../helpers/monetaryConverter';
import api from '../../../api';

import 'moment/locale/pt-br';
import locale from 'antd/es/date-picker/locale/pt_BR';

import './edit-sales-goal.css';

function EditSalesGoal(props) {
    const { userData } = useContext(Context);
    const { salesGoal } = props;
    let { responsible } = salesGoal;
    const [editMode, setEditMode] = useState(false)
    const { TextArea } = Input;
    const [responsibles, setResponsibles] = useState([]);

    const [value, setValue] = useState('')
    const [clientPayment, setClientPayment] = useState('')
    const [commissionPayment, setCommissionPayment] = useState('')
    const [month, setMonth] = useState('')

    const [formLoad, setFormLoad] = useState(false);

    const [form] = Form.useForm();

    function changeMonetaryField(val, setter) {
        let v = val;
        v = v.replace(/\D/g, "")
        v = v.replace(/(\d{1})(\d{14})$/, "$1.$2")
        v = v.replace(/(\d{1})(\d{11})$/, "$1.$2")
        v = v.replace(/(\d{1})(\d{8})$/, "$1.$2")
        v = v.replace(/(\d{1})(\d{5})$/, "$1.$2")
        v = v.replace(/(\d{1})(\d{1,2})$/, "$1,$2")
        setter("R$ " + v)
    }

    function formatMonetaryToNumber(val) {
        if (!val) return undefined
        return val.replace("R$ ", '').replace(/\./g, '').replace(',', '.')
    }

    function onChangeMonth(date, dateString) {
        if (dateString) {
            setMonth(dateString)
        }
    }

    function onChangeClientPayment(date, dateString) {
        setClientPayment(dateString || '')
    }

    function onChangeCommissionPayment(date, dateString) {
        setCommissionPayment(dateString || '')
    }

    function handleCommissionPercent(e) {
        const val = e.target.value.replace(/[^0-9.,]/g, '');
        return val;
    }

    function toggleEditMode() {
        if (!editMode) {
            // Pre-fill fields
            if (salesGoal.value) changeMonetaryField(salesGoal.value, setValue)
            setClientPayment(salesGoal.clientPayment || '')
            setCommissionPayment(salesGoal.commissionPayment || '')
            setMonth(salesGoal.month || '')
        }
        setEditMode(!editMode)
    }

    const onFinish = async values => {
        setFormLoad(true)

        let newData = {
            responsible: userData.roles.includes('admin') ? values.responsible : salesGoal.responsible?._id,
            month: month || salesGoal.month,
            company: values.company,
            value: formatMonetaryToNumber(value),
            effectiveDate: values.effectiveDate,
            operator: values.operator,
            clientPayment: clientPayment || undefined,
            commissionPercent: values.commissionPercent,
            commissionPayment: commissionPayment || undefined,
            contractBonus: values.contractBonus,
            listing: values.listing,
            obs: values.obs
        }

        await api.put(`/sales-goals/${salesGoal._id}`, newData)
            .then(async response => {
                form.resetFields();
                setFormLoad(false)
                setEditMode(false)
                message.success('Meta de venda atualizada!');

                let url = `/sales-goals?&page=${props.page}`

                if (props.filters.month)
                    url = url.concat(`&month=${props.filters.month}`)

                if (props.filters.operator)
                    url = url.concat(`&operator=${props.filters.operator}`)

                if (props.filters.responsible)
                    url = url.concat(`&responsible=${props.filters.responsible}`)

                if (props.filters.search)
                    url = url.concat(`&search=${props.filters.search}`)

                const { data } = await api.get(url);
                props.setSalesGoals(data.salesGoals)
                props.setModalSalesGoal(false)

            }).catch(error => {
                console.log(error)
                setFormLoad(false)
            })
    };

    return (
        <Modal
            visible={props.modalSalesGoal}
            onCancel={() => { props.setModalSalesGoal(false); setFormLoad(false); form.resetFields(); setEditMode(false); }}
            className="modal-customer"
            footer={false}
            width={900}
            centered
            maskClosable={false}
        >
            <Form
                form={form}
                onFinish={onFinish}
                initialValues={{
                    company: salesGoal.company,
                    effectiveDate: salesGoal.effectiveDate,
                    operator: salesGoal.operator?._id,
                    commissionPercent: salesGoal.commissionPercent,
                    contractBonus: salesGoal.contractBonus,
                    listing: salesGoal.listing,
                    obs: salesGoal.obs,
                }}
            >
                <Spin tip="Atualizando meta de venda..." spinning={formLoad}>
                    <div className="modal-customer-header">
                        <div className="modal-customer-header-data">
                            {!editMode &&
                                <p><b>Criado dia:</b> <Moment format="DD/MM/YYYY">{salesGoal.createdAt}</Moment></p>
                            }
                            {!editMode &&
                                <p><b>Mês:</b> {salesGoal.month}</p>
                            }
                            {!editMode && salesGoal.responsible &&
                                <p><b>Vendedor:</b> {salesGoal.responsible.name}</p>
                            }
                        </div>
                        <div className="modal-customer-header-actions" style={{ display: 'flex' }}>
                            <Button type="dashed" style={{ display: 'flex' }} onClick={toggleEditMode}>
                                {!editMode
                                    ? <span>Editar</span>
                                    : <span>Cancelar</span>
                                }
                            </Button>
                            {editMode && <Button type="primary" style={{ marginLeft: '15px' }} className="green" htmlType="submit">Salvar Alterações</Button>}
                        </div>
                    </div>
                    <Row className="modal-customer-body">
                        <Col span={12} className="col-resume">
                            {editMode &&
                                <p><b>Mês:</b>
                                    <Form.Item>
                                        <DatePicker
                                            picker="month"
                                            format="MM/YYYY"
                                            placeholder="Selecione o mês"
                                            locale={locale}
                                            style={{ width: '60%' }}
                                            onChange={onChangeMonth}
                                        />
                                    </Form.Item>
                                </p>
                            }

                            <p><b>Empresa:</b> {editMode ? <Form.Item name="company"><Input defaultValue={salesGoal.company} /></Form.Item> : salesGoal.company}</p>

                            <p><b>Valor:</b> {editMode
                                ? <Form.Item><Input value={value} onChange={(e) => changeMonetaryField(e.target.value, setValue)} /></Form.Item>
                                : salesGoal.value
                                    ? <MonetaryConverter quantity={salesGoal.value} class="plan-price" />
                                    : '-'
                            }</p>

                            <p><b>Data Vigência:</b> {editMode ? <Form.Item name="effectiveDate"><Input defaultValue={salesGoal.effectiveDate} /></Form.Item> : salesGoal.effectiveDate || '-'}</p>

                            <p><b>Operadora:</b> {editMode
                                ? <Form.Item name="operator">
                                    <Select placeholder="Selecione uma operadora" defaultValue={salesGoal.operator?._id} showSearch
                                        optionFilterProp="children"
                                        filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        {props.wallets &&
                                            props.wallets.map((wallet) => (
                                                <Select.Option key={wallet._id} value={wallet._id}>{wallet.name}</Select.Option>
                                            ))
                                        }
                                    </Select>
                                </Form.Item>
                                : salesGoal.operator ? salesGoal.operator.name : '-'
                            }</p>

                            <p><b>Listagem:</b> {editMode ? <Form.Item name="listing"><Input defaultValue={salesGoal.listing} /></Form.Item> : salesGoal.listing || '-'}</p>

                            {editMode && (userData.roles.includes('admin') || userData.roles.includes('specialist')) &&
                                <p><b>Vendedor:</b>
                                    <Form.Item name="responsible">
                                        <Select placeholder="Selecione um vendedor" defaultValue={responsible ? responsible._id : ''} style={{ width: '80%' }} showSearch
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            {props.users &&
                                                props.users.map((user) => (
                                                    <Select.Option key={user._id} value={user._id}>{user.name}</Select.Option>
                                                ))
                                            }
                                        </Select>
                                    </Form.Item>
                                </p>
                            }
                        </Col>
                        <Col span={12} className="col-plan" style={{ borderRight: 'none' }}>
                            <p><b>Pgto Cliente:</b> {editMode
                                ? <Form.Item>
                                    <DatePicker
                                        format="DD/MM/YYYY"
                                        placeholder="Selecione a data"
                                        locale={locale}
                                        onChange={onChangeClientPayment}
                                    />
                                </Form.Item>
                                : salesGoal.clientPayment || '-'
                            }</p>

                            <p><b>Comissão %:</b> {editMode
                                ? <Form.Item name="commissionPercent" normalize={(value) => value.replace(/[^0-9.,]/g, '')}>
                                    <Input defaultValue={salesGoal.commissionPercent} style={{ width: '30%' }} inputMode="decimal" />
                                </Form.Item>
                                : salesGoal.commissionPercent ? `${salesGoal.commissionPercent}%` : '-'}</p>

                            <p><b>Pgto Comissão:</b> {editMode
                                ? <Form.Item>
                                    <DatePicker
                                        format="DD/MM/YYYY"
                                        placeholder="Selecione a data"
                                        locale={locale}
                                        onChange={onChangeCommissionPayment}
                                    />
                                </Form.Item>
                                : salesGoal.commissionPayment || '-'
                            }</p>

                            <p><b>Tempo de Contrato:</b> {editMode
                                ? <Form.Item name="contractBonus">
                                    <Select placeholder="Selecione o tempo" style={{ width: '60%' }} defaultValue={salesGoal.contractBonus}>
                                        <Select.Option value="12 meses">12 meses</Select.Option>
                                        <Select.Option value="24 meses">24 meses</Select.Option>
                                    </Select>
                                </Form.Item>
                                : salesGoal.contractBonus || '-'
                            }</p>

                            {salesGoal.customer &&
                                <p><b>Cliente vinculado:</b> {salesGoal.customer.company}</p>
                            }

                            <h3 style={{ marginTop: '20px' }}>Observações:</h3>
                            <p>{editMode ? <Form.Item name="obs"><TextArea style={{ height: '100px' }} defaultValue={salesGoal.obs} /></Form.Item> : salesGoal.obs || '-'}</p>
                        </Col>
                    </Row>
                </Spin>
            </Form>
        </Modal>
    )
}

export default EditSalesGoal;
